import { FC } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import classNames from 'classnames';
import { AmplienceImage } from 'components/amplience/types';
import { imageAmplienceToUrl } from 'helpers/utils/amplience/imageAmplienceToUrl';
import { amplienceImageLoader } from 'helpers/utils/amplience/imageLoader';
import { gtmMenuNavigation } from 'helpers/utils/gtm-events/gtmInteraction';

export interface AmplienceNavItemProps {
  isBold: boolean;
  link: string;
  title: string;
  ariaLabel?: string;
  image?: [
    {
      image: AmplienceImage;
      altImage?: string;
    },
  ];
  isFooterColumn?: boolean;
}

const AmplienceNavItem: FC<AmplienceNavItemProps> = ({ isBold, link, title, image, isFooterColumn, ariaLabel }) => {
  return (
    <li>
      {image && image?.length > 0 ? (
        <Link
          onClick={() => {
            gtmMenuNavigation({
              click_location: isFooterColumn ? 'footer' : 'header',
              click_name: image[0].altImage ?? '',
            });
          }}
          href={link || ''}
          aria-label={ariaLabel}
        >
          <div className={`relative ${isFooterColumn ? 'h-[175px] w-full' : 'h-[264px] w-[275px]'}`}>
            <Image
              loader={amplienceImageLoader}
              fill={true}
              className={`${isFooterColumn ? 'object-fit' : 'object-cover'}`}
              src={imageAmplienceToUrl(image[0].image)}
              sizes="20vw"
              alt={image[0].altImage || 'Alt text'}
              loading="eager"
            />
          </div>
        </Link>
      ) : (
        <Link
          onClick={() => {
            gtmMenuNavigation({ click_location: isFooterColumn ? 'footer' : 'header', click_name: title });
          }}
          href={link || ''}
          className={classNames('text-[13px] text-[#222222] hover:underline', { 'font-bold': isBold })}
          aria-label={ariaLabel}
        >
          {title}
        </Link>
      )}
    </li>
  );
};

export default AmplienceNavItem;
